// extracted by mini-css-extract-plugin
export var errorsContainer = "_vm-1";
export var link = "_vm-0";